const enum PlayerVideoProviderEnum {
  QQQ = '3Q',
  YOUTUBE = 'youtube',
};

export default PlayerVideoProviderEnum;
